import type { ExperimentalMutations } from '../__types__/ExperimentalMutations';
import { MediaType } from '../MediaType';
import { throwErrorWithResponse } from '../throwErrorWithResponse';

export const experimentalRevertContent: ExperimentalMutations['experimentalRevertContent'] = (
	_,
	{ contentId },
	{ network: { cfetch } },
) => {
	if (!contentId) {
		return Promise.reject(new Error('contentId is missing'));
	}

	return cfetch(`/wiki/rest/collab/1.0/content/${contentId}/changes/unpublished`, {
		method: 'DELETE',
		headers: {
			'Content-Type': MediaType.JSON,
		},
	}).then(
		(response) => response.ok,
		(err) =>
			throwErrorWithResponse(new Error(`Failed to revert or delete draft: ${err}`), err?.response),
	);
};
